import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import ServiceListColumnsMenu from '../../components/services/list/ServiceListColumnsMenu'
import { actionCreators } from '../../state/actions/services/index'
import { getServiceListColumns } from '../../state/reducers/services'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    columns: getServiceListColumns(state)
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    onUpdateColumns: (columns: string[]) => {
      dispatch(actionCreators.serviceListUpdateColumns(columns))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceListColumnsMenu)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceListColumnsMenu.ts